import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, AlertTriangleIcon } from 'lucide-react';
export function HiddenCost() {
  return <section className="w-full py-6 md:py-8" data-id="element-89" data-mp="2vmzopano4507">
      <div className="max-w-xl mx-auto px-4 md:px-6" data-id="element-90" data-mp="30m3z24mbw8s4">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative rounded-2xl border-2 border-red-500/60 bg-[#141414] p-5 md:p-6" style={{
        boxShadow: '0 0 24px rgba(239, 68, 68, 0.15), inset 0 0 0 1px rgba(239, 68, 68, 0.08)'
      }} data-id="element-91" data-mp="30kj2k9ggefrm">
          {/* Alert tag */}
          <div className="flex justify-center mb-3" data-id="element-92" data-mp="16fkhkef93hu">
            <div className="inline-flex items-center gap-1.5 bg-red-500/10 border border-red-500/30 rounded-full px-2.5 py-1" data-id="element-93" data-mp="16yveh5nmrmd">
              <span className="relative flex h-1.5 w-1.5" data-id="element-94" data-mp="vvu0juw6kq5c">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-95" data-mp="vu97k9pilf9l" />
                <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-red-500" data-id="element-96" data-mp="qytv9m75nrfa" />
              </span>
              <span className="text-[9px] md:text-[10px] font-bold uppercase tracking-[0.2em] text-red-500" data-id="element-97" data-mp="m00sootepktw">
                Alerta · Desgaste semanal
              </span>
            </div>
          </div>

          {/* Title */}
          <h2 className="text-center font-['Open_Sans',_sans-serif] text-lg md:text-2xl font-[900] text-white leading-tight mb-1" data-id="element-98" data-mp="19v3esp0tta6o">
            Dejá de pagar con tu{' '}
            <span className="text-red-500" data-id="element-99" data-mp="14uo301w70aqt">tiempo libre.</span>
          </h2>

          {/* Subtitle */}
          <p className="text-center text-gray-400 text-[11px] md:text-xs mb-4" data-id="element-100" data-mp="1xl68f9ke2o7e">
            El costo oculto de improvisar la consulta:
          </p>

          {/* Hero stat */}
          <div className="text-center mb-4" data-id="element-101" data-mp="3rv4mjd1ngdfb">
            <div className="flex items-baseline justify-center gap-1.5" data-id="element-102" data-mp="n07fgjp5q5y">
              <span className="text-4xl md:text-5xl font-black text-red-500 leading-none" data-id="element-103" data-mp="3i38aey2qams3">
                +100
              </span>
              <span className="text-xl md:text-2xl font-black text-red-500" data-id="element-104" data-mp="3n1joxm3yxlgn">
                hrs
              </span>
            </div>
            <p className="mt-1.5 text-[9px] md:text-[10px] uppercase tracking-[0.2em] text-white font-bold" data-id="element-105" data-mp="3918uk93g9oqq">
              Perdidas al año de tu vida personal
            </p>
          </div>

          {/* Divider */}
          <div className="h-px bg-gradient-to-r from-transparent via-red-500/25 to-transparent mb-4" data-id="element-106" data-mp="2z6p8otu9815k" />

          {/* Stat rows */}
          <div className="space-y-2" data-id="element-107" data-mp="xchoero4qymy">
            <div className="bg-white/5 border border-red-500/20 rounded-xl p-2.5 md:p-3 flex items-center gap-3" data-id="element-108" data-mp="xdix4phob91i">
              <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-red-500/10 border border-red-500/25 flex items-center justify-center" data-id="element-109" data-mp="129zwygy8jbuf">
                <ClockIcon size={16} className="text-red-500" data-id="element-110" data-mp="2hvk1lqnkqect" />
              </div>
              <div className="min-w-0" data-id="element-111" data-mp="2wjy2hw1fjsqq">
                <p className="text-white font-bold text-xs md:text-sm leading-tight" data-id="element-112" data-mp="2wkzmwr4c5rl4">
                  2 a 4 horas por semana
                </p>
                <p className="text-gray-400 text-[11px] leading-snug" data-id="element-113" data-mp="2rrd8atem3dmo">
                  armando materiales y explicaciones a mano.
                </p>
              </div>
            </div>

            <div className="bg-white/5 border border-red-500/20 rounded-xl p-2.5 md:p-3 flex items-center gap-3" data-id="element-114" data-mp="30nm8iaaeyg9v">
              <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-red-500/10 border border-red-500/25 flex items-center justify-center" data-id="element-115" data-mp="3ajpn4fmgc7dp">
                <AlertTriangleIcon size={16} className="text-red-500" data-id="element-116" data-mp="1l5sv0t20d0qn" />
              </div>
              <div className="min-w-0" data-id="element-117" data-mp="1g6ga4dup63qp">
                <p className="text-white font-bold text-xs md:text-sm leading-tight" data-id="element-118" data-mp="1g7ixibst9o1v">
                  Fines de semana, noches y familia
                </p>
                <p className="text-gray-400 text-[11px] leading-snug" data-id="element-119" data-mp="c71iat88t38t">
                  tiempo que ya no vuelve.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}